// @mui
import { Icon } from '@iconify/react/dist/iconify.js';
import { Box, ButtonBase, FormLabel, Grid } from '@mui/material';
// import "./form.css"
import CheckBoxGroup from '../Form/CheckBoxGroup';
import CustomAutocomplete from '../Form/CustomAutocomplete';
import CustomSelect from '../Form/CustomSelect';
import CustomSelectChip from '../Form/CustomSelectChip';
import CustomSelectMultiple2 from '../Form/CustomSelectMultiple';
import CustomSelectableCard from '../Form/CustomSelectableCard';
import CustomTextField from '../Form/CustomTextField';
import CustomizedDatePicker from '../Form/DatePicker';
import RadioButtonGroupInGrid from '../Form/RadioButtonGroupInGrid';
import AppDialog from './AppDialog';
import { useState } from 'react';

// utils

// ----------------------------------------------------------------------

const PopOverFilter = ({ children, marginLeft, marginRight, handleResetFilter, filterData, open, isMobile, setDialogOpen, applyFilter }) => {
    const [expandedModules, setExpandedModules] = useState([]);

    const toggleExpand = (name) => {
        setExpandedModules((prev) =>
            Array.isArray(prev) && prev?.length > 0 && prev?.includes(name)
                ? prev?.filter((m) => m !== name)
                : [...(Array.isArray(prev) ? prev : []), name]
        );
    };

    const handleParentCheckboxChange = (categoryId, isChecked, item) => {
        const category = item?.categories?.find(cat => cat.id === categoryId);
        if (!category || !Array.isArray(category.sub_categories)) {
            console.error(`Category or sub_categories not found for categoryId: ${categoryId}`);
            return;
        }

        const updatedModuleId = item?.selectedModules?.includes(categoryId) ? item?.selectedModules.filter(id => id !== categoryId)
            : [...(item?.selectedModules || []), categoryId];

        const updatedValues = isChecked
            ? [...(item?.values || []), ...category.sub_categories.map(subCat => subCat.id)]
            : (item?.values || []).filter(value => !category.sub_categories.some(subCat => subCat.id === value));

        item?.onChangeSelectedModule && item.onChangeSelectedModule(updatedModuleId);
        // item?.onChangeSelectedModule && item.onChangeSelectedModule(updatedValues);
        item?.onCategoryChange && item.onCategoryChange(updatedValues);
    };

    const renderContent = (item, index) => {
        return <Grid key={index} pb={2.5} xs={item?.xsGrid || 12} sm={item?.smGrid || 12} md={item?.mdGrid || 12} margin={"10px"}>
            {item.type === "radio" ? (
                <>
                    {item?.label && <FormLabel sx={{ fontFamily: 'FunnelSans', fontWeight: 500, fontSize: 14, margin: 0, color: "#1D1B1B", justifyContent: "space-between", display: "flex" }}>{item?.label}</FormLabel>}
                    <RadioButtonGroupInGrid
                        xs={12}
                        sm={12}

                        value={item?.value}
                        data={item?.data || []}
                        setValue={(e) => {
                            item?.onChange(e);
                        }}
                        name={item?.name}
                    />
                </>


            ) : item.type === "checkbox" ? (
                <>
                    {/* Add "Select All" checkbox */}
                    <CheckBoxGroup
                        title={item?.label}
                        data={[{ label: 'Select All', value: -1 }, ...item?.data || []]} // Include "Select All" option
                        values={item?.value || []}
                        onChange={(e, data) => { item?.onChange(e, data) }}
                        row={true}
                        xs={12}
                        sm={12}
                    />
                </>
            ) : item.type === "checkbox_by_cat" ? (
                <>
                    {item?.label && <FormLabel sx={{ fontFamily: 'FunnelSans', fontWeight: 500, fontSize: 14, margin: 0, color: "#1D1B1B", justifyContent: "space-between", display: "flex" }}>{item?.label}</FormLabel>}
                    {item?.categories?.map((category, catIndex) => (
                        <Box key={catIndex}>
                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                <CheckBoxGroup
                                    data={[{ label: category.name, value: category.id }]} // Checkbox for the name
                                    values={item?.selectedModules} // Check if category.id is in selectedModules
                                    onChange={(e, x, checked) => { handleParentCheckboxChange(category.id, checked, item); }}
                                    row={false}
                                    xs={12}
                                    sm={12}
                                />
                                <ButtonBase onClick={() => toggleExpand(category.name)}>
                                    {expandedModules?.length > 0 && expandedModules?.includes(category.name) ? <i className="ri-arrow-up-s-line" /> : <i className="ri-arrow-down-s-line" />}
                                </ButtonBase>
                            </Box>
                            {expandedModules?.length > 0 && expandedModules?.includes(category.name) && (
                                <CheckBoxGroup
                                    data={category.sub_categories.map((subCategory) => ({
                                        label: subCategory.name, // Display the name of the subcategory
                                        value: subCategory.id,
                                    }))
                                    }
                                    values={item?.values || []}
                                    onChange={(e, data) => {
                                        item?.onCategoryChange(e, data);

                                        // Check if all subcategories are ticked, then add the parent category ID to selectedModules
                                        const allSubcategoriesSelected = category.sub_categories.every(subCat => e?.includes(subCat.id));
                                        if (allSubcategoriesSelected && !item?.selectedModules?.includes(category.id)) {
                                            item?.onChangeSelectedModule && item.onChangeSelectedModule([...item?.selectedModules, category.id]);
                                        } else {
                                            // If not all subcategories are selected, remove the parent category ID from selectedModules
                                            item?.onChangeSelectedModule && item.onChangeSelectedModule(item?.selectedModules?.filter(id => id !== category.id));
                                        }
                                    }}
                                    ml={2} // Indent child checkboxes
                                    row={true}
                                    xs={12}
                                    sm={12}
                                />
                            )}
                        </Box>
                    ))}
                </>
            ) : item.type === "text" ? (
                <>
                    {item?.label && <FormLabel style={{ fontFamily: 'FunnelSans', fontWeight: 500, fontSize: 14, margin: 0, pb: 2, color: "#1D1B1B", justifyContent: "space-between", display: "flex" }}>{item?.label}</FormLabel>}
                    <CustomTextField
                        values={item?.value}

                        onChange={(e) => item?.onChange(e)}
                        placeholder={item?.placeholder}
                        type={item?.inputType || 'text'}
                    />
                </>

            ) : item.type === "select" ? (
                <>
                    {item?.label && <FormLabel style={{ fontFamily: 'FunnelSans', fontWeight: 500, fontSize: 14, margin: 0, pb: 2, color: "#1D1B1B", justifyContent: "space-between", display: "flex" }}>{item?.label}</FormLabel>}
                    <CustomSelect
                        data={item?.data || []}

                        values={item?.value || "-1"}
                        placeholder={item?.placeholder}
                        onChange={(e, value) => {
                            item?.onChange(e);
                        }}
                        valueName={item?.valueName}
                        labelName={item?.labelName} />
                </>

            ) : item.type === "multiple_select" ? (
                <><div className="pt-2"></div>
                    <CustomSelectMultiple2
                        data={item?.data || []}
                        values={item?.value || []}
                        placeholder={item?.placeholder}
                        onChange={(value) => {
                            item?.onChange(value);
                        }}
                        valueName={item?.valueName}
                        labelName={item?.labelName} />
                </>
            ) : item?.type === "autocomplete" ? (
                <CustomAutocomplete
                    data={item?.data || []}
                    values={item?.value}

                    placeholder={item?.placeholder}
                    onChange={(e, value) => {
                        item?.onChange(value);
                    }}
                    valueName={item?.valueName}
                    labelName={item?.labelName}
                />
            ) : item?.type === "date" ? (
                <>
                    {item?.label && <FormLabel style={{ fontFamily: 'FunnelSans', fontWeight: 500, fontSize: 14, margin: 0, pb: 2, color: "#1D1B1B", justifyContent: "space-between", display: "flex" }}>{item?.label}</FormLabel>}
                    <CustomizedDatePicker
                        values={item?.value && new Date(item?.value)}
                        title={item?.label}
                        fieldSize={"medium"}
                        setFormValues={(e) => item?.onChange(e)}
                    />
                </>

            ) : item?.type === "date_range" ? (
                <>
                    {item?.label && <FormLabel style={{ fontFamily: 'FunnelSans', fontWeight: 500, fontSize: 14, margin: 0, pb: 2, color: "#1D1B1B", justifyContent: "space-between", display: "flex" }}>{item?.label}</FormLabel>}
                    <Box position="relative">
                        <Grid container spacing={2} >
                            <Grid item sm={6} xs={12}>
                                <CustomizedDatePicker
                                    values={item?.startDate && new Date(item?.startDate)}
                                    title={item?.startDateTitle}
                                    placeholder={item?.startPlaceholder || item?.placeholder}
                                    setFormValues={(e) => item?.setStartDate(e)}
                                />
                            </Grid>
                            <Grid item sm={6} xs={12} sx={{ alignSelf: 'flex-end' }}>
                                <CustomizedDatePicker
                                    title={item?.endDateTitle}
                                    values={item?.endDate && new Date(item?.endDate)}
                                    setFormValues={(e) => item?.setEndDate(e)}
                                    placeholder={item?.endPlaceholder || item?.placeholder}
                                    minDate={item?.startDate && new Date(item?.startDate)}
                                />
                            </Grid>
                        </Grid>
                        <Box
                            position="absolute"
                            top="65%"
                            left="50%"
                            style={{
                                transform: 'translateX(-50%)',
                                color: '#000000ff',
                                fontSize: '10px',
                                fontWeight: 900,
                                pointerEvents: 'none'
                            }}
                        >
                            -
                        </Box>
                    </Box>
                </>

            ) : item?.type === "created_date" ?
                <>
                    <RadioButtonGroupInGrid
                        xs={12}
                        sm={12}
                        title={item?.label}
                        value={item?.value}
                        data={Headers?.createDateOptions}
                        setValue={(e) => { item?.onChange(e) }}
                        name={item?.name}
                    />
                    {
                        item?.value === 'custom' &&
                        <Grid container spacing={2} >
                            <Grid item sm={6} xs={12}>
                                <CustomizedDatePicker
                                    title={"From"}
                                    values={item?.startDate && new Date(item?.startDate)}
                                    setFormValues={(e) => item?.setStartDate(e)}
                                />
                            </Grid>
                            <Grid item sm={6} xs={12}>
                                <CustomizedDatePicker
                                    title={"To"}
                                    values={item?.endDate && new Date(item?.endDate)}
                                    setFormValues={(e) => item?.setEndDate(e)}
                                    minDate={item?.startDate && new Date(item?.startDate)}
                                />
                            </Grid>
                        </Grid>
                    }
                </>
                : item?.type === "range" ?
                    <Grid container spacing={2} >
                        {item?.label && <FormLabel sx={{ fontFamily: 'FunnelSans', fontWeight: 500, fontSize: 14, margin: 0, color: "#1D1B1B", justifyContent: "space-between", display: "flex" }}>{item?.label}</FormLabel>}
                        <Grid item sm={5.5} xs={12}>
                            <CustomTextField
                                values={item?.minValue}
                                onChange={(e) => item?.setMinAmount(e)}
                                placeholder={'0'}
                                min={item?.defaultMin}
                                type={"number"}
                                InputProps={{
                                    startAdornment: <span>{item?.prefix || ''}</span>,
                                }}
                            />
                        </Grid>
                        <Grid item sm={1} xs={12} className="d-flex align-items-center justify-content-center">
                            -
                        </Grid>
                        <Grid item sm={5.5} xs={12}>
                            <CustomTextField
                                values={item?.maxValue}
                                onChange={(e) => item?.setMaxAmount(e)}
                                max={item?.defaultMax}
                                placeholder={item?.defaultMax ? "Max: $" + item?.defaultMax : '0'}
                                type={"number"}
                                InputProps={{
                                    startAdornment: <span>{item?.prefix || ''}</span>,
                                }}
                            />
                        </Grid>
                    </Grid>
                    : item?.type === "priceRange" ?
                        <Box position="relative">
                            {item?.label && <FormLabel sx={{ fontFamily: 'FunnelSans', fontWeight: 500, fontSize: 14, margin: 0, color: "#1D1B1B", justifyContent: "space-between", display: "flex" }}>{item?.label}</FormLabel>}
                            <Grid container spacing={2} >
                                <Grid item sm={6} xs={12}>
                                    <CustomTextField
                                        values={item?.minValue}
                                        onChange={(e) => item?.setMinAmount(e)}
                                        placeholder={'Min'}
                                        min={item?.defaultMin}
                                        type={"number"}
                                        InputProps={{
                                            startAdornment: <span>{item?.prefix || ''}</span>,

                                        }}
                                    />
                                </Grid>
                                {/* <Grid item sm={1} xs={12} className="d-flex align-items-center justify-content-center">
                            -
                        </Grid> */}
                                <Grid item sm={6} xs={12} sx={{ alignSelf: 'flex-end' }}>
                                    <CustomTextField
                                        values={item?.maxValue}
                                        onChange={(e) => item?.setMaxAmount(e)}
                                        placeholder={item?.defaultMax ? "Max: $" + item?.defaultMax : '0'}
                                        max={item?.defaultMax}
                                        type={"number"}
                                        InputProps={{
                                            startAdornment: <span>{item?.prefix || ''}</span>,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Box
                                position="absolute"
                                top="59%"
                                left="50%"
                                style={{
                                    transform: 'translateX(-50%)',
                                    color: '#000000ff',
                                    fontSize: '10px',
                                    fontWeight: 900,
                                    pointerEvents: 'none'
                                }}
                            >
                                -
                            </Box>
                        </Box>
                        : item?.type === "select_chip" ?
                            <CustomSelectChip
                                values={item?.value}
                                onChange={(e, value) => {
                                    item?.onChange(value);
                                }}
                                multiple={item?.multiple}
                                data={item?.data}

                                placeholder={item?.placeholder}
                                valueName={item?.valueName}
                                labelName={item?.labelName}
                                width="100%"
                            />
                            : item?.type === "select_card" ? (
                                <>
                                    {item?.label && (
                                        <FormLabel
                                            style={{
                                                fontFamily: 'FunnelSans',
                                                fontWeight: 500,
                                                fontSize: 14,
                                                paddingBottom: '10px',
                                                margin: 0,
                                                color: '#1D1B1B',
                                            }}
                                        >
                                            {item?.label}<br />
                                            <span className="text-muted">{item?.placeholder}</span>
                                        </FormLabel>
                                    )}
                                    {item?.data?.length > 0 &&
                                        item.data.map((x) => (
                                            <CustomSelectableCard
                                                key={x.id}
                                                title={x.name}
                                                multiple={item?.multiple || false}
                                                description={x.subTitle}
                                                icon={<Icon icon={x.icon} width={24} height={24} />}
                                                selected={item?.selected(x.id)} // Pass the selected logic dynamically
                                                onSelect={() => item?.onSelect(x.id)} // Pass the onSelect handler dynamically
                                                disabled={false}
                                                width="100%"
                                                margin="10px 0"
                                                padding="15px"
                                            />
                                        ))}
                                </>

                            ) : null
            }
        </Grid>
    }

    return (
        <>
            {
                <>
                    <ButtonBase
                        style={{
                            height: 36,
                            borderRadius: 20,
                            backgroundColor: 'white',
                            color: '#101010',
                            padding: 7,
                            paddingInline: 17,
                            width: "auto",
                            border: "1px solid #c4c4c4",
                            marginRight: marginRight || 0,
                            marginLeft: marginLeft || 0,
                            display: 'flex',
                            justifyContent: 'flex-start'
                        }}
                        onClick={() => setDialogOpen(!open)}
                    >
                        More filters <Icon icon={'ri-filter-3-line'} style={{ marginRight: 5, color: '#434343', fontSize: "20px", paddingLeft: "8px" }} />
                    </ButtonBase>
                    <AppDialog
                        open={open}
                        close={() => setDialogOpen(false)}
                        title={`All Filters (${filterData?.length || 0})`}
                        positiveTitle={"Show results"}
                        positivePress={() => applyFilter()}
                        negativePress={() => handleResetFilter(false)}
                        negativeTitle={'Clear all'}
                        width={'70%'}
                        isMobile={isMobile}
                        negativeButtonStyle={{
                            borderRadius: "20px",
                            padding: 20,
                            height: 42, color: "#808588", border: "1px solid #F9F9F9", backgroundColor: "#F9F9F9"
                        }}
                    >
                        <Grid container spacing={2.5} p={2}>
                            {filterData?.length > 0 && filterData?.map((item, index) => {
                                return renderContent(item, index);
                            })}
                        </Grid>
                    </AppDialog>
                </>

            }
        </>

    );
};
export default (PopOverFilter);
